import React from 'react';
import classNames from 'classnames';

class InputFilter extends React.Component {
  constructor(...args) {
    super(...args);
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    const newValue = e.target.value;
    if (newValue != this.props.value) {
      this.props.setValue(newValue);
      this.props.applyFilters(e);
    }
  }

  render() {
    const {
      query,
      tableId,
      columnKey,
      currentColumn,
      applyFilters,
      handleKeyPress,
    } = this.props;
    const formId = `form_${tableId}`;
    const defaultValue = query[`search_${columnKey}`];
    const datatype = currentColumn.datatype;
    let type;
    switch (datatype) {
      case 'date':
        type = 'date';
        break;
      case 'integer':
        type = 'number';
        break;
      default:
        type = 'text';
    }
    const hasOperator = datatype == 'date' || datatype == 'integer';

    return (
      <input
        form={formId}
        type={type}
        onKeyPress={handleKeyPress}
        onBlur={this.onChange}
        name={`search_${columnKey}`}
        defaultValue={defaultValue}
        placeholder="Search..."
        className={classNames(
          'form-control filter-control date_search form-field-text steroid-filter border-dark',
          {
            'filter-with-operator': hasOperator,
            'filter-without-operator': !hasOperator,
          }
        )}
      />
    );
  }
}

export default InputFilter;
